module.exports = __webpack_public_path__ + "img/box7-5.65a29dac.png";